export default __webpack_public_path__ + "static/media/logo-4.1d8573a9.svg";